import { Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'jk-service';
import { JkBaseComponent, JkOpenwinParams } from 'jk-service';
import { idNameItem, jkLib, jkRestReturn } from 'jk-service';
import { Stklg } from '../../entity/Stklg-angular';
import { StklgService } from '../../services/stklg.service';
import { StkmaService } from '../../services/stkma.service';
import { StkmbService } from '../../services/stkmb.service';
import { StktuService } from '../../services/stktu.service';
import { sendButtonStyle, StockService } from '../../services/stock.service';
import { RowDoubleClickedEvent } from 'ag-grid-community';
import { StklmService, StkmrService } from '../../_service_stk';
import { AdvComModule, JkgridwinComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';
import { buysaleList, dayTradeList, newCloseList, priceTypeList, tradeTypeList } from '../../capitalClass';
import { Stkmr } from '../../entity/Stkmr-angular';
import { Stktu } from '../../entity/Stktu-angular';


@Component({
  selector: 'app-future-order',
  standalone: true,
  imports: [MaterialModule, CommonModule, JackBaseComponentModule, AdvComModule],
  templateUrl: './future-order.component.html',
  styles: [sendButtonStyle]
})
export class FutureOrderComponent extends JkBaseComponent implements OnInit {
  stktuSrv = inject(StktuService);
  stkmaSrv = inject(StkmaService);
  stkmbSrv = inject(StkmbService);
  stklmSrv = inject(StklmService);
  stockSrv = inject(StockService);
  stklgSrv = inject(StklgService);
  stkmrSrv = inject(StkmrService);

  balanceGrid!: JkgridwinComponent;
  stktuGrid!: JkgridwinComponent;
  replyGrid!: JkgridwinComponent;

  date: string = jkLib.nowDate();
  buysaleList: idNameItem[] = buysaleList;
  dayTradeList: idNameItem[] = dayTradeList;
  newCloseList: idNameItem[] = newCloseList;
  tradeTypeList: idNameItem[] = tradeTypeList;
  priceTypeList: idNameItem[] = priceTypeList;
  get futureAccount(): string {
    return this.stktuSrv.newItem.TU002;
  }
  set futureAccount(value: string) {
    this.stktuSrv.newItem.TU002 = value;
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }
  override ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => {
      if (this.stkmbSrv.futureAccountList.length > 0)
        this.futureAccount = this.stkmbSrv.futureAccountList[0].id;
      this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
    }, 1000);
  }
  afterGridReady($event: JkgridwinComponent) {
    this.stktuGrid = $event;

    this.initTabGroup();
  }
  afterGridReadyBalance($event: JkgridwinComponent) {
    this.balanceGrid = $event;

  }
  doQueryBalance(type: number) {
    let where = ``;
    //  MQ002=:MQ002 AND LG001='20241101'
    where += ` AND MR002='${this.futureAccount}' AND LG001='${this.date}'`;
    this.balanceGrid.doQuery2('STKMR', 'S03', 'S', where);

  }

  doQuery() {
    if (!this.futureAccount) return;
    let where = ` AND TU001='${this.date}' AND TU002='${this.futureAccount}'`;
    this.stktuGrid.doQuery2('STKTU', 'S01', 'S', where);
  }
  _priceType: string = '0';
  get priceType(): string {
    return this._priceType;
  }
  set priceType(value: string) {
    this._priceType = value;
    // 委託價格(IOC and FOK，可用「M」表示市價，「P」表示範圍市價)
    if (this._priceType === '0') {
      this.stktuSrv.newItem.TU010 = jkLib.fixString(this.stklg.LG010)
      this.stktuSrv.tradeType = '0'; //0:ROD
    }
    else
      if (this._priceType === '1') {
        this.stktuSrv.newItem.TU010 = 'M' // 市價
        this.stktuSrv.tradeType = '1'; // IOC
      }
      else
        if (this._priceType === '2') {
          this.stktuSrv.newItem.TU010 = 'P'; // 範圍市價
          this.stktuSrv.tradeType = '1'; // IOC
        }
  }
  get marginMoney(): number {
    return 0;
  }

  stklg: Stklg = new Stklg(); //
  stkmr: Stkmr = new Stkmr(); //
  //@Input() _stockno: string = '';
  get stockno(): string {
    return this.stktuSrv.newItem.TU005;
  }
  set stockno(value: string) {
    let r: any = this.stkmaSrv.idNameList.find((item) => item.id === value);
    if (r) {
      this.stktuSrv.newItem.TU005 = r.id;
      this.stktuSrv.newItem.TU029 = r.name;//  商品名稱
      this.stktuSrv.newItem.TU030 = '2';//商品分類
      this.getStklg(value);
      this.getStkmr(value);
    } else {
      this.stktuSrv.newItem.TU005 = '';
      this.stktuSrv.newItem.TU029 = '';
    }
  }
  async doSend() {
    let bool = await this.stktuSrv.doBeforeSend(this.stkmbSrv.uId);
    if (bool) {
      this.doSaveRemember();
      let body = {
        prid: 'SendFutureOrder',//送出期貨委託，需設倉別與盤別。
        item: this.stktuSrv.newItem,
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        await this.page.showToast('委託成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();

      } else {
        await this.page.showAlert('委託失敗:' + ret.getResultError());
      }
    }
  }
  getStklg(stockno: string) {
    this.stklgSrv.getDay(jkLib.nowDate(), stockno).subscribe(
      (value) => {
        if (value && value.length > 0)
          this.stklg = value[0];
        this.stktuSrv.newItem.TU010 = jkLib.fixString(this.stklg.LG010);
      }
    );
  }
  getStkmr(stockno: string) {
    this.stkmrSrv.getDay(stockno, this.futureAccount, this.stkmbSrv.uId).subscribe(
      (value) => {
        if (value && value.length > 0) {
          this.stkmr = value[0];
          this.stktuSrv.newItem.TU011 = this.stkmr.MR007;
        } else {
          this.stkmr = new Stkmr();
        }
      });
  }
  onDateValueChange($event: string) {
    this.doQuery();
    this.doQueryReply();
  }
  doTest() {
    this.doShowJson(this.stkmaSrv.futureList);

  }
  async doChangePrice() {
    let item: Stktu = this.stktuGrid.gridSrv.getFocusedRowData();
    if (item) {
      let newPrice = await this.page.showInput('價格:', '請輸入新價格', item.TU010, 'text');
      if (!newPrice) return;
      // Long CorrectPriceBySeqNo([in] BSTR bstrLogInID, [in] VARIANT_BOOL bAsyncOrder, [in] BSTR bstrAccount,
      //[in] BSTR bstrSeqNo, [in] BSTR bstrPrice, [in] LONG nTradeType,[out] BSTR* bstrMessage);
      let body = {
        prid: 'CorrectPriceBySeqNo',//證期權改價
        table: 'STKTU',
        key1: item.TU001,
        key2: item.TU002,
        key3: item.TU003,
        price: newPrice,
        tradeType: item.TU006, // 證券0:ROD   期選0:ROD  1:IOC  2:FOK
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        await this.page.showToast('改價成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();

      } else {
        await this.page.showAlert('改價失敗:' + ret.getResultError());
      }
    } else {
      await this.page.showAlert('請先選擇委託單');
    }

  }
  async doChangeQty() {
    let item: Stktu = this.stktuGrid.gridSrv.getFocusedRowData();
    if (item) {
      let decreaseQty = await this.page.showInput('口數:', '請輸入取消口數', item.TU011.toString(), 'text');
      if (!decreaseQty) {
        return;
      }

      let body = {
        prid: 'DecreaseOrderBySeqNo',//
        key1: item.TU001,
        key2: item.TU002,
        key3: item.TU003,
        table: 'STKTU',
        decreaseQty: jkLib.fixNumber(decreaseQty),
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        await this.page.showToast('修改口數成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();

      } else {
        await this.page.showAlert('修改口數失敗:' + ret.getResultError());
      }
    } else {
      await this.page.showAlert('請先選擇委託單');
    }

  }
  async doDelete() {
    let item = this.stktuGrid.gridSrv.getFocusedRowData();
    if (item) {
      let body = {
        prid: 'CancelOrderBySeqNo',//
        key1: item.TU001,
        key2: item.TU002,
        key3: item.TU003,
        table: 'STKTU',
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        await this.page.showToast('刪單成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();

      } else {
        await this.page.showAlert('刪單失敗:' + ret.getResultError());
      }
    } else {
      await this.page.showAlert('請先選擇委託單');
    }

  }
  doLoadRemember() {
    jkLib.loadLocalStorageItem('stktu', this.stktuSrv.newItem);
  }
  doSaveRemember() {
    jkLib.saveLocalStorageItem('stktu', this.stktuSrv.newItem);
  }
  afterGridReadyReply($event: JkgridwinComponent) {
    this.replyGrid = $event;
  }
  doQueryReply() {

    if (!this.futureAccount) return;
    let where = ` AND MarketType='TF' AND Broker+CustNo='${this.futureAccount}' AND Date1='${this.date}'`;
    this.replyGrid.doQuery2('STKLM', 'S01', 'S', where);
  }
  async doComfirm() {// 回報過帳
    let item: any = this.replyGrid.itemFocused;
    if (!item) return;
    let ret = await this.stklmSrv.confirm(item, this.serverUrl);
    if (ret.result) {
      await this.page.showToast('回報成功');
    } else {
      await this.page.showAlert('回報失敗');
    }
  }

  doOpenwinStock($event: MouseEvent) {
    let param: JkOpenwinParams = {
      isModal: true,
      maintable: 'STKMR',
      item: 'W01',
      params: [this.futureAccount],
      isMultiSelect: true,
      filterVisible: true,
      valueExpr: 'MR001',
      displayExpr: 'MA002',
      returnData: [],
    };
    /* TODO: 為了測試 暫時拿掉
    this.page.doOpenWinClick(param, (values: any) => {
      if (values) {
        this.stockno = values[0].id;
      }
    });*/
  }
  balanceGridDoubleClick($event: RowDoubleClickedEvent<any, any>) {
    // TODO:未測完
    let selectedItem = $event.data;
    if (selectedItem) {
      if (this.balanceGrid.maintable === 'STKMR') {
        this.stockno = selectedItem.MR001;
        this.stktuSrv.qty = selectedItem.MR007;
        if (selectedItem['買賣別'] === '賣') {
          this.stktuSrv.buysale = '0'; // 買
        } else {
          this.stktuSrv.buysale = '1';
        }
        this.stktuSrv.newClose = '1'; // 平倉
      }
      this.masterTabGroupIndex = 0;
    }
  }

}
